import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
export var getUrlParamsWithoutDecode = function getUrlParamsWithoutDecode(_ref) {
  var url = _ref.url,
      _ref$decode = _ref.decode,
      decode = _ref$decode === void 0 ? false : _ref$decode;
  url = url || window.location.href;
  if (url.indexOf('?') < 0) return {};
  return url.replace(/^.+?\?/, '').replace(/#.+/, '').split('&').filter(function (param) {
    return param;
  }).reduce(function (obj, param) {
    var i = param.indexOf('=');
    var t = [param.slice(0, i), param.slice(i + 1)];
    obj[t[0]] = decode ? decodeURIComponent(t[1]) : t[1];
    return obj;
  }, {});
};
/**
 * 数据类型判断
 * @param  {Mix}     subject 待判断的数据
 * @param  {String}  type    数据类型名字
 * @return {Boolean}         判断结果
 */

export function is(subject, type) {
  return Object.prototype.toString.call(subject).substr(8, type.length).toLowerCase() === type;
}
/**
 * 是否是对象
 * @param  {Mix} subject 待判断的数据
 */

export function isObject(subject) {
  return is(subject, 'object');
}